import React from 'react';
import { useQuery } from 'react-query';

import { FinesPerStatementByMunicipalityReportForm } from '@project/components/forms';
import { statementRunService } from '@project/services';

export const FinesPerStatementByMunicipalityReportOrganism: React.FC = () => {
  const { isFetching, data } = useQuery('statementRuns', statementRunService.get, {
    refetchOnWindowFocus: false,
  });

  const sortData = data?.sort((a, b) =>
    a.startedDate < b.startedDate ? 1 : a.startedDate > b.startedDate ? -1 : 0,
  );

  return isFetching ? null : (
    <FinesPerStatementByMunicipalityReportForm
      defaultValues={{
        statementRunId: sortData[0].id,
        offenceDate: null,
      }}
      selectValues={sortData.map((statementRun) => {
        return {
          value: `${statementRun.name} (${statementRun.startedDate})`,
          key: statementRun.id,
        };
      })}
    />
  );
};
